import { Helmet } from "react-helmet-async";

const ORIGIN = typeof window !== "undefined" ? window.location.origin : "https://partners.communitytax.com";
const DEFAULT_IMG =
  "https://static.prod-images.emergentagent.com/jobs/d9b67bb3-e7d0-4c69-ae20-98aaa401b970/images/b18cae97e450b8f22b992b1e5cf1db7492ef4f09d42ba69479800ad726e5d84a.png";

export default function Seo({ title, description, path = "/", image = DEFAULT_IMG, jsonLd }) {
  const url = `${ORIGIN}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Community Tax Partners" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
